module.exports = __webpack_public_path__ + "img/7.5c41a6b3.png";